import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Stack } from "@similarweb/ui-components/foundations";

import { StyledManagementCardWrapper } from "app/pages/sales-intelligence/modules/manage-integrations/components/cards-components/styles";

export const StyledEmptyStateCard = styled(StyledManagementCardWrapper)`
    align-items: center;
    justify-content: center;
    gap: 12px;
    cursor: pointer;
    border: 1px solid transparent;
    transition:
        border-color 150ms ease,
        background-color 150ms ease;

    &:hover {
        border-color: ${colorsPalettes.blue[400]};
    }
`;

export const StyledEmptyStateContent = styled(Stack)`
    align-items: center;
    gap: 12px;
`;
